import { heroEntries, heroStats, heroTags } from '@/mocks/home';

interface HeroProps {
  notify: (msg: string) => void;
}

export default function Hero({ notify }: HeroProps) {
  return (
    <section className="relative isolate overflow-hidden bg-primary-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20crimson%20and%20amber%20gradient%20background%20with%20soft%20flowing%20paper%20texture%20and%20subtle%20geometric%20grid%20lines%2C%20editorial%20poster%20style%2C%20minimal%20flat%20vector%20illustration%2C%20cream%20and%20deep%20red%20tones%2C%20clean%20harmonious%20composition&width=1600&height=900&seq=baogua-hero-01&orientation=landscape"
        alt="爆瓜福利资源包与素材内容合集门户首页背景"
        title="爆瓜福利资源包下载 网盘文件素材内容合集"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/85 to-primary-900/55"></div>
      <div className="relative w-full px-4 py-14 md:px-8 md:py-20">
        <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap items-center gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h2 className="mt-6 font-heading text-3xl font-black leading-[1.18] text-background-50 md:text-5xl">
              找瓜不迷路
              <br />
              <span className="text-accent-400">爆瓜福利资源包</span> 一站聚合
            </h2>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              爆瓜福利资源包、网盘文件与素材内容合集统一整理，热门爆料和吃瓜资料持续更新。
              点开即可进入爆瓜福利下载入口，按类型取用，省去到处翻找的时间。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={() => notify('已获取爆瓜福利资源包下载入口')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-download-2-line text-base"></i>
                </span>
                获取资源包下载入口
              </button>
              <button
                type="button"
                onClick={() => notify('正在为你打开热门话题墙')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-hashtag text-base"></i>
                </span>
                浏览话题标签墙
              </button>
            </div>

            <dl className="mt-8 grid grid-cols-2 gap-4 border-t border-background-50/15 pt-6 sm:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-2xl font-black text-background-50">
                    {stat.value}
                    <span className="ml-1 text-sm font-medium text-accent-400">{stat.unit}</span>
                  </dt>
                  <dd className="mt-1 text-xs text-background-300">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-xl border border-background-50/15 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h4 className="font-heading text-base font-bold text-foreground-950">快捷下载入口</h4>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] text-accent-900">今日已更新</span>
              </div>
              <div className="mt-4 flex flex-col gap-2.5">
                {heroEntries.map((entry) => (
                  <button
                    key={entry.title}
                    type="button"
                    onClick={() => notify(`已进入「${entry.title}」`)}
                    className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-3 text-left transition-colors hover:border-primary-300 hover:bg-primary-50"
                  >
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                      <i className={`${entry.icon} text-lg`}></i>
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-medium text-foreground-950">{entry.title}</span>
                      <span className="mt-0.5 block text-xs text-foreground-500">{entry.desc}</span>
                    </span>
                    <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600">
                      {entry.action}
                      <span className="flex h-3.5 w-3.5 items-center justify-center transition-transform group-hover:translate-x-0.5">
                        <i className="ri-arrow-right-s-line"></i>
                      </span>
                    </span>
                  </button>
                ))}
              </div>
              <p className="mt-4 flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-2 text-xs text-secondary-800">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-information-line text-sm"></i>
                </span>
                所有入口均为站内聚合展示，取用前请留意文件说明
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}